import { installationTaskSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

const responseSchema = z.object({
  plannedSensors: z.array(installationTaskSchema),
  plannedGateways: z.array(installationTaskSchema),
});

interface Params {
  projectId: string;
  installationId?: string;
  enabled?: boolean;
  noRetry?: boolean;
}

export function useInstallationTasks({
  projectId,
  installationId,
  enabled = true,
  noRetry = false,
}: Params) {
  const queryKey = ['installation-tasks', { projectId, installationId }];
  const url = `/projects/${projectId}/installation-tasks${objectToQueryParams({
    installationId,
  })}`;

  const { data, error, isLoading, refetch, isFetching } = useQuery({
    queryKey,
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!enabled && !!projectId,
    retry: !noRetry,
  });

  return {
    plannedSensors: data?.plannedSensors || [],
    plannedGateways: data?.plannedGateways || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
